<template>
  <div v-if="entry" class="content">
    {{ company.companyName }}
    <div
      v-for="(item, idx) in entry.diaryEntries"
      :key="idx"
      class="d-flex align-items-center justify-content-center fill-width"
    >
      <diary-entry-company-item-edit :diaryEntry="diaryEntry" :entry="entry" :item="item" style="flex-grow: 2" />
      <button v-if="!isLastEntry(idx)" @click="removeItem(idx)" class="icon-button">
        <b-icon icon="dash-circle" />
      </button>
      <button v-if="isLastEntry(idx)" @click="addItem" class="icon-button">
        <b-icon icon="plus-circle" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DiaryEntryCompanyItemEdit from '@/components/diary/DiaryEntryCompanyItemEdit.vue';

export default {
  name: 'DiaryEntryCompany',

  components: {
    DiaryEntryCompanyItemEdit,
  },

  props: ['entry', 'diaryEntry'],

  methods: {
    ...mapActions(['diaryEntryAddItem', 'diaryEntryRemoveItem']),

    isLastEntry(index) {
      return index === this.entry.diaryEntries.length - 1;
    },

    addItem() {
      this.diaryEntryAddItem({ diaryEntry: this.diaryEntry, entry: this.entry });
    },

    removeItem(idx) {
      this.diaryEntryRemoveItem({ diaryEntry: this.diaryEntry, entry: this.entry, index: idx });
    },
  },

  computed: {
    ...mapGetters(['getCompany']),

    company() {
      return this.getCompany(this.entry.companyId);
    },
  },
};
</script>

<style scoped>
.icon-button {
  font-size: 2rem;
  color: rgb(146, 146, 146);
  margin-left: 5px;
}

.icon-button:hover {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/diary/DiaryEntryCompany.vue